import React from "react";
import { useMediaQuery } from "@mui/material";
import Snackbar, { SnackbarProps } from "@mui/material/Snackbar";
import { Alert, AlertColor, AlertTitle } from "@mui/material";
import { theme } from "@/theme";

export interface NotificationProps extends SnackbarProps {
  severity?: AlertColor;
}

const Notification = (props: NotificationProps) => {
  const { message, title, severity, action, ...rest } = props;
  const isSmallScreen = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.sm)
  );

  return (
    <Snackbar
      autoHideDuration={6000}
      anchorOrigin={
        isSmallScreen
          ? { vertical: "bottom", horizontal: "center" }
          : { vertical: "bottom", horizontal: "right" }
      }
      style={!isSmallScreen ? { width: "100%", maxWidth: 327 } : {}}
      {...rest}
    >
      <Alert
        severity={severity}
        variant="outlined"
        sx={{ width: "100%", bgcolor: "background.paper" }}
        action={action}
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </Snackbar>
  );
};

export { Notification };
